import ApiClient from "../Utils/ApiClient";
import Config from "../Config/Config";

const apiClient = new ApiClient(Config.baseURL);

export default apiClient;
